import _extends from "@babel/runtime/helpers/extends";
import { App, ConfigProvider } from "antd";
import { RootStore } from "../store";
import { IconProvider } from "@ant-design/icons";
const Provider = _ref => {
  let {
    children,
    configProvider = {},
    app = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfigProvider, _extends({
    prefixCls: process.env.ANTD_PREFIX,
    iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
    theme: {
      token: {
        // Match devowl.io WordPress theme
        colorPrimary: "#45b3dd",
        borderRadius: 3,
        fontSize: 15,
        colorText: "#666666",
        colorBgContainer: "#f2f4f7"
      },
      components: {
        Button: {
          colorPrimaryHover: "#469bc3"
        },
        Table: {
          colorBgContainer: "white"
        }
      }
    }
  }, configProvider), /*#__PURE__*/React.createElement(IconProvider, {
    value: {
      prefixCls: `${process.env.ANTD_PREFIX}-anticon`
    }
  }, /*#__PURE__*/React.createElement(App, _extends({
    message: {
      top: 150
    }
  }, app), /*#__PURE__*/React.createElement(RootStore.StoreProvider, null, children))));
};
export { Provider };